"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StylePopover;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = _interopRequireDefault(require("./styles"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _Theme = require("../../contexts/Theme");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Auth = require("../../contexts/Auth");
var _Preference = _interopRequireDefault(require("../../api/Preference"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function StylePopover(_ref) {
  var {
    open,
    setOpen,
    anchorEl,
    anchorOrigin,
    transformOrigin
  } = _ref;
  var HASH = 'style';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var {
    scale,
    setScale,
    theme,
    setTheme,
    THEME
  } = (0, _Theme.useTheme)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var classes = (0, _styles.default)();
  var tracking = (0, _Trackings.default)(auth);
  var {
    applicationToken,
    sessionToken,
    userId
  } = auth;
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpen(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, open, setOpen]);
  (0, _react.useEffect)(() => {
    if (open) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [open]);
  function onScaleChange(scale) {
    setScale(scale);
    tracking.trackChangeFontSize(parseInt(scale * 100) + '%');
    onSavePreferences(scale, theme);
  }
  function onThemeChange(theme) {
    setTheme(theme);
    tracking.trackChangeBackgroundColor(theme.label);
    onSavePreferences(scale, theme);
  }
  function onSavePreferences(scale, theme) {
    var themeId = Object.entries(THEME).find(item => item[1] === theme)[0];
    var settings = {
      font_size: scale,
      background_style: themeId,
      columns: 'one'
    };
    _Preference.default.save(applicationToken, sessionToken, userId, settings);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: Boolean(open),
    onClose: () => setOpen(),
    anchorEl: anchorEl,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title,
    variant: "h6",
    color: "textSecondary"
  }, "Estilo", /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.closePopover,
    onClick: () => setOpen()
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseSharp, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, "Tamanho do p\xE1gina"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.scaleContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.scaleText
  }, parseInt(scale * 100), "%"), /*#__PURE__*/_react.default.createElement(_saraivaUi.IncreaseReduceButton, {
    handleIncrease: () => onScaleChange(parseFloat((scale - 0.1).toFixed(2))),
    handleDecrease: () => onScaleChange(parseFloat((scale + 0.1).toFixed(2))),
    disableIncrease: parseInt(scale * 100) <= 10,
    disableDecrease: parseInt(scale * 100) >= 200
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, "Cor de fundo"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.themeContainer
  }, Object.values(THEME).map((item, index) => /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    key: index,
    label: item.label,
    backgroundColor: item.reader.backgroundColor,
    selected: item === theme,
    onClick: () => onThemeChange(item)
  })))));
}